(function () {
  'use strict';

  function init(root) {
    if (!root || root.dataset.mccReady === 'true') return;
    root.dataset.mccReady = 'true';

    var locale = root.dataset.locale || document.documentElement.lang || 'en';
    var currency = root.dataset.currency || (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR';
    var variantNode = root.querySelector('[data-mcc-variants]');
    var variants = [];
    try { variants = JSON.parse(variantNode.textContent); } catch (error) { variants = []; }

    function money(cents) {
      try {
        return new Intl.NumberFormat(locale, { style: 'currency', currency: currency }).format(Number(cents) / 100).replace(/\u202f/g, ' ');
      } catch (error) {
        return (Number(cents) / 100).toFixed(2) + ' ' + currency;
      }
    }

    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-mcc-slide]'));
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-mcc-thumb]'));
    var gallery = root.querySelector('[data-mcc-gallery]');
    var preloadNextOnly = gallery && gallery.hasAttribute('data-mcc-preload-next');
    var current = 0;
    var galleryRequest = 0;

    function preloadSlide(index) {
      if (!slides.length) return Promise.resolve();
      var normalized = (index + slides.length) % slides.length;
      var image = slides[normalized] && slides[normalized].querySelector('img');
      if (!image) return Promise.resolve();
      if (image.dataset.mccLoaded === 'true' || (image.complete && image.naturalWidth > 0)) {
        image.dataset.mccLoaded = 'true';
        return image.decode ? image.decode().catch(function () {}) : Promise.resolve();
      }

      image.loading = 'eager';
      return new Promise(function (resolve) {
        var loader = new Image();
        var settled = false;
        function done() {
          if (settled) return;
          settled = true;
          image.dataset.mccLoaded = 'true';
          if (loader.decode) loader.decode().catch(function () {}).then(resolve);
          else resolve();
        }
        loader.onload = done;
        loader.onerror = done;
        if (image.srcset) loader.srcset = image.srcset;
        if (image.sizes) loader.sizes = image.sizes;
        loader.src = image.currentSrc || image.src;
      });
    }

    function warmAdjacent(index) {
      preloadSlide(index + 1);
      if (!preloadNextOnly) preloadSlide(index - 1);
    }

    function activateSlide(index) {
      current = index;
      slides.forEach(function (slide, i) { slide.classList.toggle('is-active', i === current); });
      thumbs.forEach(function (thumb, i) {
        thumb.classList.toggle('is-active', i === current);
        thumb.setAttribute('aria-selected', i === current ? 'true' : 'false');
      });
      if (thumbs[current]) thumbs[current].scrollIntoView({ block: 'nearest', inline: 'nearest' });
      warmAdjacent(current);
    }

    function showSlide(index) {
      if (!slides.length) return;
      var target = (index + slides.length) % slides.length;
      var request = ++galleryRequest;
      preloadSlide(target).then(function () {
        if (request !== galleryRequest) return;
        activateSlide(target);
      });
    }
    warmAdjacent(current);
    thumbs.forEach(function (thumb) { thumb.addEventListener('click', function () { showSlide(Number(thumb.dataset.mccThumb)); }); });
    var prev = root.querySelector('[data-mcc-gallery-prev]');
    var next = root.querySelector('[data-mcc-gallery-next]');
    if (prev) prev.addEventListener('click', function () { showSlide(current - 1); });
    if (next) next.addEventListener('click', function () { showSlide(current + 1); });
    if (gallery) {
      var touchStart = null;
      gallery.addEventListener('touchstart', function (event) { touchStart = event.changedTouches[0].clientX; }, { passive: true });
      gallery.addEventListener('touchend', function (event) {
        if (touchStart === null) return;
        var distance = event.changedTouches[0].clientX - touchStart;
        if (Math.abs(distance) > 42) showSlide(current + (distance < 0 ? 1 : -1));
        touchStart = null;
      }, { passive: true });
    }

    var form = root.querySelector('#mcc-product-form');
    var atc = root.querySelector('[data-mcc-atc]');
    var sticky = root.querySelector('[data-mcc-sticky]');
    var hiddenId = root.querySelector('[data-mcc-variant-id]');
    var subscriptionToggles = Array.prototype.slice.call(root.querySelectorAll('[data-mcc-subscription]'));
    var pricingSubscriptionToggles = Array.prototype.slice.call(root.querySelectorAll('[data-mcc-pricing-subscription]'));
    var sellingPlanInput = root.querySelector('[data-mcc-selling-plan]');
    var offerLabels = Array.prototype.slice.call(root.querySelectorAll('[data-mcc-offer]'));
    var subscriptionSelected = false;
    function selectedVariant() {
      var input = root.querySelector('input[name="mcc-offer"]:checked');
      if (!input) return variants[0] || null;
      return variants.filter(function (variant) { return String(variant.id) === String(input.value); })[0] || null;
    }
    function setText(selector, value) {
      Array.prototype.forEach.call(root.querySelectorAll(selector), function (node) { node.textContent = value; });
    }
    function syncOffer() {
      var input = root.querySelector('input[name="mcc-offer"]:checked');
      var label = input && input.closest('[data-mcc-offer]');
      var sellingPlanId = label && label.dataset.sellingPlanId ? label.dataset.sellingPlanId : '';
      if (subscriptionSelected && !sellingPlanId) subscriptionSelected = false;
      offerLabels.forEach(function (offer) {
        var selected = offer === label;
        offer.classList.toggle('is-selected', selected);
        offer.classList.toggle('is-subscribed', selected && subscriptionSelected);
      });
      subscriptionToggles.forEach(function (toggle) {
        toggle.checked = subscriptionSelected && !!label && label.contains(toggle);
      });
      if (sellingPlanInput) {
        sellingPlanInput.value = subscriptionSelected ? sellingPlanId : '';
        sellingPlanInput.disabled = !subscriptionSelected;
      }
      var variant = selectedVariant();
      if (!variant) return;
      hiddenId.value = variant.id;
      var subscriptionPrice = label && label.dataset.subscriptionPrice ? Number(label.dataset.subscriptionPrice) : Number(variant.price);
      var activePrice = subscriptionSelected ? subscriptionPrice : Number(variant.price);
      var compareCents = subscriptionSelected && activePrice < Number(variant.price) ? Number(variant.price) : Number(variant.compare_at_price || 0);
      var price = money(activePrice);
      var compare = compareCents > activePrice ? money(compareCents) : '';
      setText('[data-mcc-top-price]', price);
      setText('[data-mcc-atc-price]', price);
      setText('[data-mcc-sticky-price]', price);
      setText('[data-mcc-top-compare]', compare);
      setText('[data-mcc-atc-compare]', compare);
      var saving = label ? label.dataset.saving : '';
      if (variant.compare_at_price && Number(variant.compare_at_price) > activePrice) {
        saving = Math.round((1 - activePrice / Number(variant.compare_at_price)) * 100) + '%';
      }
      setText('[data-mcc-saving]', saving);
      if (atc) atc.disabled = variant.available === false;
    }
    root.querySelectorAll('input[name="mcc-offer"]').forEach(function (input) { input.addEventListener('change', syncOffer); });

    function selectedSellingPlan() {
      if (!subscriptionSelected || !sellingPlanInput) return null;
      var rawId = String(sellingPlanInput.value || '').split('/').pop();
      return /^\d+$/.test(rawId) ? Number(rawId) : null;
    }
    subscriptionToggles.forEach(function (toggle) {
      toggle.addEventListener('change', function () {
        var offer = toggle.closest('[data-mcc-offer]');
        var radio = offer && offer.querySelector('input[name="mcc-offer"]');
        if (toggle.checked && radio) radio.checked = true;
        subscriptionSelected = toggle.checked;
        syncOffer();
      });
    });
    pricingSubscriptionToggles.forEach(function (toggle) {
      toggle.addEventListener('change', function () {
        if (!toggle.checked) return;
        pricingSubscriptionToggles.forEach(function (other) {
          if (other !== toggle) other.checked = false;
        });
      });
    });
    syncOffer();

    function submitProduct() {
      if (!form || form.dataset.busy === 'true') return;
      var variant = selectedVariant();
      if (!variant) return;
      form.dataset.busy = 'true';
      if (atc) atc.disabled = true;
      if (sticky) sticky.disabled = true;
      var selectedInput = root.querySelector('input[name="mcc-offer"]:checked');
      var selectedLabel = selectedInput && selectedInput.closest('[data-mcc-offer]');
      var offerTitle = selectedLabel ? selectedLabel.querySelector('.mcc-offer__copy strong').textContent.trim() : variant.title;
      var cartItem = { id: Number(variant.id), quantity: 1, properties: { Offer: offerTitle } };
      var sellingPlanId = selectedSellingPlan();
      if (sellingPlanId) cartItem.selling_plan = sellingPlanId;
      document.dispatchEvent(new CustomEvent('cart:add', {
        detail: {
          source: 'quillmore-ceylon-cinnamon',
          items: [cartItem],
          onSuccess: function () { form.dataset.busy = 'false'; if (sticky) sticky.disabled = false; syncOffer(); },
          onError: function () { form.dataset.busy = 'false'; if (sticky) sticky.disabled = false; syncOffer(); }
        }
      }));
    }
    if (form) form.addEventListener('submit', function (event) { event.preventDefault(); submitProduct(); });
    if (sticky) sticky.addEventListener('click', submitProduct);
    root.querySelectorAll('[data-mcc-select-offer]').forEach(function (button) {
      button.addEventListener('click', function () {
        var input = root.querySelector('input[name="mcc-offer"][value="' + button.dataset.mccSelectOffer + '"]');
        var pricingCard = button.closest('.mcc-pricing-fidelity__grid article');
        var pricingSubscription = pricingCard && pricingCard.querySelector('[data-mcc-pricing-subscription]');
        subscriptionSelected = !!(pricingSubscription && pricingSubscription.checked);
        if (input) { input.checked = true; syncOffer(); }
        submitProduct();
      });
    });
    root.querySelectorAll('[data-mcc-scroll-buy]').forEach(function (button) {
      button.addEventListener('click', function () { root.querySelector('#mcc-buybox').scrollIntoView({ behavior: 'smooth', block: 'start' }); });
    });

    if (sticky && atc && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var entry = entries[0];
        sticky.classList.toggle('is-visible', !entry.isIntersecting && entry.boundingClientRect.bottom < 0);
      }, { threshold: 0.05 }).observe(atc);
    }

    var counters = root.querySelectorAll('[data-mcc-count]');
    if ('IntersectionObserver' in window) {
      var counterObserver = new IntersectionObserver(function (entries, observer) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var node = entry.target;
          var target = Number(node.dataset.mccCount || 0);
          var started = performance.now();
          function tick(now) {
            var progress = Math.min((now - started) / 950, 1);
            node.textContent = Math.floor(target * (1 - Math.pow(1 - progress, 3))) + '%';
            if (progress < 1) requestAnimationFrame(tick);
          }
          requestAnimationFrame(tick);
          observer.unobserve(node);
        });
      }, { threshold: 0.25 });
      counters.forEach(function (node) { counterObserver.observe(node); });
    } else {
      counters.forEach(function (node) { node.textContent = node.dataset.mccCount + '%'; });
    }

    if ('IntersectionObserver' in window) {
      var autoVideos = root.querySelectorAll('.mcc-customer-videos video');
      var videoObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) entry.target.play().catch(function () {});
          else entry.target.pause();
        });
      }, { threshold: 0.45 });
      autoVideos.forEach(function (video) { videoObserver.observe(video); });
    }

    var reviewRow = root.querySelector('.mcc-review-cards');
    var reviewCards = reviewRow ? Array.prototype.slice.call(reviewRow.querySelectorAll('[data-mcc-review]')) : [];
    var reviewIndex = 0;
    var reviewCounter = root.querySelector('[data-mcc-review-counter]');
    function moveReview(step) {
      if (!reviewCards.length) return;
      reviewIndex = (reviewIndex + step + reviewCards.length) % reviewCards.length;
      reviewCards[reviewIndex].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
      if (reviewCounter) reviewCounter.textContent = (reviewIndex + 1) + ' / ' + reviewCards.length;
    }
    var reviewPrev = root.querySelector('[data-mcc-review-prev]');
    var reviewNext = root.querySelector('[data-mcc-review-next]');
    if (reviewPrev) reviewPrev.addEventListener('click', function () { moveReview(-1); });
    if (reviewNext) reviewNext.addEventListener('click', function () { moveReview(1); });
  }

  function boot() { document.querySelectorAll('[data-mcc-root]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
